var amdi18n={"__root":{"MY_JOURNEYS":"My Journeys","CREATE_JOURNEY":"Create Journey","NO_JOURNEY_CREATED":"You don't have any journey created"},"__fr":{"MY_JOURNEYS":"Mes Parcours","CREATE_JOURNEY":"Créer un parcours","NO_JOURNEY_CREATED":"Vous n'avez créé aucun parcours créee"},"__en":{"MY_JOURNEYS":"My Journeys","CREATE_JOURNEY":"Create Journey","NO_JOURNEY_CREATED":"You don't have any journey created"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(typeof window !== 'undefined' && window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(typeof document !== 'undefined' && document.documentElement.lang){
				language = document.documentElement.lang;
			}else if(typeof navigator !== 'undefined' && (navigator.languages || navigator.language || navigator.userLanguage)){
				// navigator.languages does not exist in IE 11
				language = (navigator.languages && navigator.languages[0]) ||
					navigator.language ||
					navigator.userLanguage;
				language = (language || 'root').toLowerCase();
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		var recursiveFallback = function(target, source){
			for(var name in source){
				switch(typeof target[name]){
				case 'undefined':
					target[name] = source[name];
					break;
				case 'object':
					recursiveFallback(target[name], source[name]);
				}
			}
		};
		recursiveFallback(this, this.__root);
	};amdi18n.init();module.exports=amdi18n;